import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { get, put } from "../services/apiClient";

export interface MealSlot {
  label: string;
  timeOfDay: string;
  items: string[];
  sortOrder: number;
  allowOthers: boolean;
  isAvailable: boolean;
  servingCapacity: number;
}

export interface DayMenu {
  dayOfWeek: number;
  slots: MealSlot[];
}

export interface FoodMenuEntity {
  id?: string;
  businessId: string;
  days: DayMenu[];
}

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const DAY_FULL_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const foodMenuKeys = {
  detail: (businessId: string) => ["food-menu", businessId] as const,
};

export const useFoodMenu = (businessId: string) =>
  useQuery<FoodMenuEntity>({
    queryKey: foodMenuKeys.detail(businessId),
    queryFn: () => get<FoodMenuEntity>(`/food-menu/${businessId}`),
    enabled: !!businessId,
  });

export const useUpsertFoodMenu = (businessId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (days: DayMenu[]) =>
      put<FoodMenuEntity>(`/food-menu/${businessId}`, { days }),
    onSuccess: (data) => {
      qc.setQueryData(foodMenuKeys.detail(businessId), data);
    },
  });
};
